import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import {
  ServerStateProvider,
  ThemeProvider,
  PublicConfigProvider,
  GoogleApiProvider,
} from '@pv/common/providers';
import { apiHost } from '@pv/common/api';
import { ErrorBoundary } from '@pv/common/components';
import { PVSnackbarProvider } from './providers/SnackbarProvider';

import './App.css';
import { AvailabilityProvider } from './providers/AvailabilityProvider';
import { PostHogProvider } from './providers/PostHogProvider';
import { AuthProvider } from './contexts/AuthContext';
import { AppRoutes } from './AppRoutes';

interface AppProps {}

const pvEnv = process.env.REACT_APP_PV_ENV as string;
const API_HOST = apiHost(pvEnv);

const App: FC<AppProps> = (props: AppProps) => {
  return (
    <PublicConfigProvider apiHost={API_HOST} waitForConfig={false}>
      <ErrorBoundary>
        <ServerStateProvider apiHost={API_HOST}>
          <ThemeProvider>
            <PostHogProvider>
              <GoogleApiProvider>
                <BrowserRouter>
                  <PVSnackbarProvider>
                    <AuthProvider>
                      <AvailabilityProvider>
                        <AppRoutes />
                      </AvailabilityProvider>
                  </AuthProvider>
                </PVSnackbarProvider>
              </BrowserRouter>
            </GoogleApiProvider>
          </PostHogProvider>
          </ThemeProvider>
        </ServerStateProvider>
      </ErrorBoundary>
    </PublicConfigProvider>
  );
};

export default App;
